package org.vreo.devicehub.features.userAuthentication.presentation.verification

/**
 * Account verification actions, actions allowed by the view
 */
sealed interface AccountVerificationActions {
    class OnClearError : AccountVerificationActions
    class OnBackNavigationClicked : AccountVerificationActions
    data class OnVerifyClicked(val callback: ((String) -> Unit)? = null) :
        AccountVerificationActions
    class OnUpdateVerificationCode(val value: String) : AccountVerificationActions
    class OnResendVerificationCodeClicked : AccountVerificationActions

}